<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar dense>
          <v-toolbar-title>
            <div class="text-left">
              <h3>Domains</h3>
            </div>
          </v-toolbar-title>
          <v-btn absolute dark bottom small right fab @click.stop="dialogAddDomain = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <DomainList />

    <v-dialog v-model="dialogAddDomain" max-width="1200" style="width:90%">
      <v-card>
        <v-banner color="transparent" single-line>
          <span class="title">Add new Domain</span>
          <template v-slot:actions>
            <v-btn class="ma-2" outlined x-small fab type="submit" @click="addNewDomain">
              <v-icon>mdi-floppy</v-icon>
            </v-btn>
          </template>
        </v-banner>
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="6" sm="6" md="6">
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-title>
                    <v-text-field
                      label="Domain"
                      hide-details="auto"
                      v-model="newDomain.domain"
                      outlined
                      placeholder="Domain"
                    ></v-text-field>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-text>
                    Backoffice
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="Backoffice URL"
                        hide-details="auto"
                        v-model="newDomain.backoffice.url"
                        outlined
                        placeholder="Backoffice URL"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="Backoffice User"
                        hide-details="auto"
                        v-model="newDomain.backoffice.user"
                        outlined
                        placeholder="Backoffice User"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="Backoffice Password"
                        hide-details="auto"
                        v-model="newDomain.backoffice.password"
                        outlined
                        placeholder="Backoffice Password"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-text>
                    cPanel
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="cPanel URL"
                        hide-details="auto"
                        v-model="newDomain.cPanel.url"
                        outlined
                        placeholder="cPanel URL"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="cPanel User"
                        hide-details="auto"
                        v-model="newDomain.cPanel.user"
                        outlined
                        placeholder="cPanel User"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="cPanel Password"
                        hide-details="auto"
                        v-model="newDomain.cPanel.password"
                        outlined
                        placeholder="cPanel Password"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-text>
                    FTP
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="FTP URL"
                        hide-details="auto"
                        v-model="newDomain.ftp.url"
                        outlined
                        placeholder="FTP URL"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="FTP User"
                        hide-details="auto"
                        v-model="newDomain.ftp.user"
                        outlined
                        placeholder="FTP User"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="FTP Password"
                        hide-details="auto"
                        v-model="newDomain.ftp.password"
                        outlined
                        placeholder="FTP Password"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-text>
                    Observations
                    <div style="margin:20px 0px">
                      <v-textarea
                        outlined
                        v-model="newDomain.observations"
                        placeholder="Observations"
                        label="Observations"
                      ></v-textarea>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DomainList from "@/components/domain/DomainList.vue";

import { mapActions } from "vuex";
export default {
  name: "domainlist",
  components: {
    DomainList
  },
  data() {
    return {
      domains: null,
      newDomain: this.createEmptyDomain(),
      dialogAddDomain: false
    };
  },
  methods: {
    ...mapActions(["createNewDomain"]),
    addNewDomain() {
      this.newDomain.creationDate = new Date();
      this.createNewDomain(this.newDomain);
      this.newDomain = this.createEmptyDomain();
      this.dialogAddDomain = false;
    },
    createEmptyDomain() {
      return {
        domain: null,
        backoffice: {
          url: null,
          user: null,
          password: null
        },
        ftp: {
          url: null,
          user: null,
          password: null
        },
        cPanel: {
          url: null,
          user: null,
          password: null
        },
        observations: null,
        creationDate: null
      };
    }
  }
};
</script>

<style></style>
